import * as React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { AutoSizer } from 'react-virtualized/dist/es/AutoSizer';
import { List } from 'react-virtualized/dist/es/List';
import * as cx from 'classnames';

import { searchArea } from 'actions/regions/areas';

import IconButton from 'material-ui/IconButton/IconButton';
import SearchIcon from 'material-ui/svg-icons/action/search';

import Search from './Search';
import Filter from './Filter';

class FilterAreas extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            areaName: '',
            filter: 'all',
            filteredAreas: [],
        };

        this.changeSearch = this.changeSearch.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.checkSelect = this.checkSelect.bind(this);

        this.renderRow = this.renderRow.bind(this);
    }

    checkSelect(item) {
        this.state.filteredAreas.forEach((area) => {
            if (item._id === area._id) {
                area.isActive = true;
                return;
            }

            area.isActive = false;
        });

        this.setState({
            filteredAreas: this.state.filteredAreas,
        }, () => {
            this.props.onSelectArea(_.cloneDeep(item));
        });
    }

    filterAreas(areas) {
        let filteredAreas = areas.filter((area, i) => {
            if (area.name.toLowerCase().includes(this.state.areaName.toLowerCase())) {
                return true;
            }

            if (!area.fields) {
                return false;
            }

            for (let areaKey = 0; areaKey <= area.fields.length; areaKey++) {
                if (area.fields[areaKey].name.toLowerCase().includes(this.state.areaName.toLowerCase())) {
                    return true;
                }
            }

            return false;
        });

        switch(this.state.filter){
            case 'noPorts':
                return filteredAreas.filter((area) => {
                    return area.childs.length === 0;
                });
            case 'noMainPorts':
                return filteredAreas.filter((area) => {
                    return !(area.mainPorts && area.mainPorts.length > 0);
                });
            default:
                return filteredAreas;
        }
    }

    changeSearch(value) {
        this.setState({
            areaName: value,
        }, () => {
            this.setState({
                filteredAreas: this.filterAreas(this.props.areas.items),
            });
        });
    }

    changeFilter(value) {
        this.setState({
            filter: value,
        }, () => {
            this.setState({
                filteredAreas: this.filterAreas(this.props.areas.items),
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            filteredAreas: this.filterAreas(nextProps.areas.items),
        })
    }

    componentDidUpdate() {
        if (this.props.selectedArea) {
            const areaIndex = this.state.filteredAreas.findIndex(area => area._id === this.props.selectedArea);

            this.list.scrollToRow(areaIndex);
        }
    }

    renderRow({ index, key, style }) {
        const { filteredAreas } = this.state;
        
        const area = filteredAreas[index];
        const selected = this.props.selectedArea === area._id;
        const parentCount = (area.parents || [])
            .map(id => this.props.areas.items.find(a => a._id === id))
            .reduce((count, area) => area ? count + 1 : count, 0);

        return (
            <div
                style={{ ...style, display: 'flex', justifyContent: 'space-between', fontWeight: area.mainRegion ? 'bold' : 'normal'}}
                key={key}
                className={cx('list-item', { active: selected })}
                onClick={() => { this.checkSelect(area) }}
            >
                <div style={{ lineHeight: '16px', paddingTop: '8px' }}>
                    {area.name}
                    <div style={{ fontSize: 'smaller' }}>
                        <b style={{ color: parentCount > 1 ? 'rgb(255, 64, 129)' : '' }}>
                            {parentCount}
                        </b>
                        {parentCount === 1 ? " parent " : " parents "}
                        <b>{area.childAreaCount}</b>
                        {area.childAreaCount === 1 ? " child " : " children "}
                        <b>{area.childPortCount}</b>
                        {area.childPortCount === 1 ? " port" : " ports"}
                    </div>
                </div>
                <IconButton onClick={() => {
                    this.props.searchArea(area.name);
                    this.props.router.push('/regions/altareas')
                }}>
                    <SearchIcon />
                </IconButton>
            </div>
        );
    }

    render() {
        const { filteredAreas } = this.state;
        const { selectedArea, areas } = this.props;

        console.log('render selectedArea', selectedArea);

        return (
            <div className='area-panel'>
                <Search changeSearch={this.changeSearch} />
                <Filter changeFilter={this.changeFilter} />

                <div className='paper-block margin-10 area-list'>
                    <span className='name-block absolute small-name'>Areas to select</span>

                    <div className='list'>
                        <AutoSizer>
                            {
                                ({ width, height }) => {
                                    return <List
                                        ref={list => { this.list = list; } }
                                        _updateOnly={areas}
                                        selectedArea={selectedArea} // only to cause update
                                        rowRenderer={this.renderRow}
                                        height={height}
                                        width={width}
                                        rowHeight={48}
                                        rowCount={filteredAreas.length}
                                    />
                                }
                            }
                        </AutoSizer>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, { selectedArea, areas, onSelectArea, router }) => {
        return {
            selectedArea,
            areas,
            onSelectArea,
            router,
        };
    },
    dispatch => bindActionCreators({
            searchArea,
        },
        dispatch),
)(FilterAreas);



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/FilterAreas/Component.jsx